// note: datatables is required in via bootstrap script
import 'bootstrap';
require('./bootstrap');

// jQuery plugins
require('floating-form-labels');
require('parsleyjs');
require('./typeahead');
require('./select2');
require('./dropzone');

// Common
require('./ajax-setup');
require('./common');

// Page specific
require('./login');
require('./approvals');
require('./users');
require('./finance');
require('./conditions');
require('./customer-conditions');
require('./customer-condition-min-reqs');
require('./customer-special-conditions');
require('./supplier-conditions');
require('./supplier-condition-min-reqs');
require('./solaris-condition-min-reqs');
require('./supplier-special-conditions');
require('./application');
require('./application-supplier-accreditation');
require('./stock-finance');
require('./product-category');
require('./product-types');
require('./approvals-priorities');
require('./approvals-matrix');
require('./integrations');
require('./suppliers');
